<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" ></style>

<script setup>
import { ref, computed, watch } from 'vue'
import { useStore } from 'vuex'
import BaseModal from '@/components/BaseModal/index.vue'

const props = defineProps({
  modelValue: { type: Boolean, default: false },
})

const emit = defineEmits(['update:modelValue'])

const store = useStore()
const isOpen = computed({
  get: () => props.modelValue,
  set: (v) => emit('update:modelValue', v),
})

const loading = ref(false)
const error = ref(null)
const contentHtml = ref('')

async function fetchContent() {
  loading.value = true
  error.value = null
  contentHtml.value = ''
  try {
    const html = await store.dispatch('checkout/getShippingInfo')
    contentHtml.value = html
  } catch (e) {
    const message = e?.response?.status
      ? `Failed to load: ${e.response.status}`
      : (e?.message || 'Failed to load shipping information')
    error.value = message
  } finally {
    loading.value = false
  }
}

watch(
  () => props.modelValue,
  (open) => {
    if (open) fetchContent()
  },
  { immediate: true }
)

defineExpose({ fetchContent })
</script>
